const BASE = (accountId) => `/api/v1/ozon-unit-economics/${accountId}`;

const periodQuery = ({ dateFrom, dateTo, ...rest }) => {
  const params = new URLSearchParams();
  if (dateFrom) params.set('date_from', dateFrom);
  if (dateTo) params.set('date_to', dateTo);
  Object.entries(rest).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, value);
  });
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

const accountIdsQuery = (accountIds, hasOtherParams) =>
  (accountIds || []).map((id, i) => `${i === 0 && !hasOtherParams ? '?' : '&'}account_ids=${encodeURIComponent(id)}`).join('');

export const econSync = ({ request, accountId, dateFrom, dateTo, force = false }) =>
  request(`${BASE(accountId)}/sync${periodQuery({ dateFrom, dateTo, force: force ? 'true' : '' })}`, {
    method: 'POST',
  });

export const econSyncState = ({ request, accountId, dateFrom, dateTo }) =>
  request(`${BASE(accountId)}/sync-state${periodQuery({ dateFrom, dateTo })}`);

export const econDashboard = ({ request, accountId, dateFrom, dateTo }) =>
  request(`${BASE(accountId)}/dashboard${periodQuery({ dateFrom, dateTo })}`);

export const econBreakdown = ({ request, accountId, dateFrom, dateTo, groupBy = 'sku' }) =>
  request(`${BASE(accountId)}/breakdown${periodQuery({ dateFrom, dateTo, group_by: groupBy })}`);

export const econSettingsGet = ({ request, accountId }) =>
  request(`${BASE(accountId)}/settings`);

export const econSettingsSave = ({ request, accountId, payload }) =>
  request(`${BASE(accountId)}/settings`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const econOtherList = ({ request, accountId, dateFrom, dateTo }) =>
  request(`${BASE(accountId)}/other-expenses${periodQuery({ dateFrom, dateTo })}`);

export const econOtherCreate = ({ request, accountId, payload }) =>
  request(`${BASE(accountId)}/other-expenses`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const econOtherUpdate = ({ request, accountId, id, payload }) =>
  request(`${BASE(accountId)}/other-expenses/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const econOtherDelete = ({ request, accountId, id }) =>
  request(`${BASE(accountId)}/other-expenses/${id}`, { method: 'DELETE' });

export const econCogsList = ({ request, accountId, dateFrom, dateTo }) =>
  request(`${BASE(accountId)}/cogs${periodQuery({ dateFrom, dateTo })}`);

export const econCogsSave = ({ request, accountId, items }) =>
  request(`${BASE(accountId)}/cogs`, {
    method: 'POST',
    body: JSON.stringify({ items }),
  });

export const econProjectDashboard = ({ request, accountIds, dateFrom, dateTo }) =>
  request(`/api/v1/ozon-unit-economics/project/dashboard${periodQuery({ dateFrom, dateTo })}${accountIdsQuery(accountIds, dateFrom || dateTo)}`);

export const econProjectBreakdown = ({ request, accountIds, dateFrom, dateTo, groupBy = 'sku' }) =>
  request(`/api/v1/ozon-unit-economics/project/breakdown${periodQuery({ dateFrom, dateTo, group_by: groupBy })}${accountIdsQuery(accountIds, true)}`);
